export default {
  computed: {
    snowSafetyConsole() {
      let product = this.products.find(p => p.type === 'snowSafetyConsole')
      let variant = product.variants.find(v => v.color == this.selections.accessoryColor.value)
      let fullProduct = { ...product, ...variant }
      delete fullProduct.variants;

      if (this.safetySystem == 'PW') {
        fullProduct = this.getPWConsoleProduct();
      }

      // Calculate amount
      // AFFECTS NUM TRACKTILES
      let rooftileCC = this.rooftile.cc
      let maxDistanceConsole = this.rooftile.maxDistanceConsole



      let distanceConsole = this.maxDistance < maxDistanceConsole ?
        maxDistanceConsole / 1000 :
        Math.floor(this.maxDistance / rooftileCC) * rooftileCC / 1000

      // From productCalcUtil imported in summarystep
      let rows = this.rowsSnowprotection

      let amount = 0
      let roofSafetyLengths = this.selections.roofSafetyLengths.value
      let roofSafetyRaisedLengths = this.selections.roofSafetyRaisedLengths.value
      let snowProtectionLength = this.snowProtection['length'] / 1000
      const buffer = this.safetySystem == 'SAFE' ? 0.3 : 0.4

      const getConsolesFixed = (distance) => {
        if (isNaN(Number(distance))) return null

        // 50cm buffer before rounding up
        const totalSafe = Math.max(0, Math.ceil((+distance - 0.5) / snowProtectionLength))
        const totalConsole = totalSafe * snowProtectionLength
        const consoles = totalConsole / distanceConsole

        return Math.max(0, consoles - buffer)
      }

      amount = roofSafetyLengths.reduce((acc, distance) => {
        const consolesFixed = getConsolesFixed(distance)
        if (consolesFixed === null) return acc

        return acc + Math.ceil(consolesFixed) + 1;
      }, 0)

      const raisedAmount = roofSafetyRaisedLengths.reduce((acc, distance) => {
        const consolesFixed = getConsolesFixed(distance)
        if (consolesFixed === null) return acc

        return acc + Math.ceil(1.5 * consolesFixed) + 1;
      }, 0)

      amount = (amount + raisedAmount) * rows

      // Add properties
      fullProduct.amount = amount
      fullProduct.raisedAmount = raisedAmount * rows; // Save this separately to calculate elevation mounts
      // fullProduct.pallets =  1,
      // fullProduct.totalWeight =  2,
      // fullProduct.values =  1,
      fullProduct.unit = 'st';

      if (this.safetySystem == 'SAFE' && variant.artNumber !== '170390') {
        let bigpack = this.bigpack(fullProduct, amount);
        fullProduct.singlepack = bigpack[0];
        fullProduct.bigpack = bigpack[1];
        fullProduct.sort = 2
      }else {
        fullProduct.singlepack = amount;
      }

      return fullProduct
    }
  },
  methods: {}
}
